import { createSelector } from '@reduxjs/toolkit';
import { selectLandArea, selectTotalArea } from 'shared/selectors/jsonQuery';
import { selectSuburbanAreaLabel } from './selectSuburbanAreaLabel';

export const selectSuburbanAreaFilter = createSelector(
  [selectTotalArea, selectLandArea, selectSuburbanAreaLabel],
  (houseArea, landArea, label) => {
    const { gte: houseAreaMin = null, lte: houseAreaMax = null } = houseArea || {};
    const { gte: landAreaMin = null, lte: landAreaMax = null } = landArea || {};

    return {
      label,
      value: {
        houseAreaMin,
        houseAreaMax,
        landAreaMin,
        landAreaMax,
      },
    };
  },
);
